import { render, staticRenderFns } from "./EditConstrain.vue?vue&type=template&id=07b0b48b"
import script from "./EditConstrain.vue?vue&type=script&lang=ts"
export * from "./EditConstrain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports